import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Nav, NavItem } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap/lib';
import { disableChangePasswordFunctionality } from 'util/utils';

// A pure component version of would fail to update the component when expected
// Hence this is a Component instead of a PureComponent
// eslint-disable-next-line react/prefer-stateless-function
export default class EmployeeNav extends Component {
  render() {
    const { user } = this.props;
    return (
      <Nav bsStyle="tabs">
        <LinkContainer to={`/employees/user/${user.id}/edit`}>
          <NavItem>Edit</NavItem>
        </LinkContainer>
        <LinkContainer to={`/employees/user/${user.id}/access`}>
          <NavItem>Dealership Access</NavItem>
        </LinkContainer>
        <LinkContainer to={`/employees/user/${user.id}/changePassword`}>
          <NavItem disabled={disableChangePasswordFunctionality()}>
            Change Password
          </NavItem>
        </LinkContainer>
      </Nav>
    );
  }
}

EmployeeNav.propTypes = {
  employee: PropTypes.object,
};
